import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { isNative } from "./platform";

// Servizio fotocamera riutilizzabile (prova consegna rider, documenti, foto attivita', AI vision...).
// Ritorna { dataUrl, blob, file } oppure null (annullato/negato).
export async function capturePhoto({ source = "prompt", quality = 70 } = {}) {
  if (isNative()) {
    try {
      const src = source === "camera" ? CameraSource.Camera
        : source === "photos" ? CameraSource.Photos : CameraSource.Prompt;
      const photo = await Camera.getPhoto({
        quality, resultType: CameraResultType.DataUrl, source: src,
        correctOrientation: true, allowEditing: false, presentationStyle: "fullscreen",
      });
      const dataUrl = photo.dataUrl;
      const blob = await (await fetch(dataUrl)).blob();
      const ext = (photo.format || "jpeg").replace("jpg", "jpeg");
      const file = new File([blob], `photo_${Date.now()}.${ext}`, { type: blob.type || "image/jpeg" });
      return { dataUrl, blob, file };
    } catch (e) { return null; }
  }
  // Web: input file nascosto (capture=environment su mobile web = fotocamera).
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file"; input.accept = "image/*";
    if (source === "camera") input.setAttribute("capture", "environment");
    input.onchange = () => {
      const file = input.files && input.files[0];
      if (!file) return resolve(null);
      const reader = new FileReader();
      reader.onload = () => resolve({ dataUrl: reader.result, blob: file, file });
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    };
    input.click();
  });
}

export async function ensureCameraPermission() {
  if (!isNative()) return true;
  try {
    const p = await Camera.checkPermissions();
    if (p.camera === "granted") return true;
    const r = await Camera.requestPermissions({ permissions: ["camera", "photos"] });
    return r.camera === "granted" || r.photos === "granted";
  } catch (e) { return false; }
}
